import { Box, MenuItem, useTheme } from "@mui/material";
import { StyledSelect } from "./styled";
import { ISelectProps } from "./types";

const Select = (props: ISelectProps) => {
    const { options = [], value, onChange, ...rest } = props;
    const theme = useTheme();
    
    // Encontrar o placeholder (primeira opção com value vazio)
    const placeholderOption = options.find(opt => opt.value === '' || opt.value === null || opt.value === undefined);
    const displayValue = value || '';
    
    return (
        <StyledSelect 
            value={displayValue} 
            onChange={onChange}
            options={options}
            displayEmpty
            renderValue={(selected) => {
                if (!selected || selected === '') {
                    return (
                        <Box component="span" sx={{ color: theme.palette.text.secondary, opacity: 0.8 }}>
                            {placeholderOption?.label || ''}
                        </Box>
                    );
                }
                const selectedOption = options.find(opt => opt.value === selected);
                return selectedOption?.label || '';
            }}
            {...rest}
        >
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                    {option.label}
                </MenuItem>
            ))}
        </StyledSelect>
    )
}

export { Select };
